/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDim2DiagMaxRightIcon16Light } from './ArrowDim2DiagMaxRightIcon16Light';
import { ArrowDim2DiagMaxRightIcon16Regular } from './ArrowDim2DiagMaxRightIcon16Regular';
import { ArrowDim2DiagMaxRightIcon16Solid } from './ArrowDim2DiagMaxRightIcon16Solid';
import { ArrowDim2DiagMaxRightIcon20Light } from './ArrowDim2DiagMaxRightIcon20Light';
import { ArrowDim2DiagMaxRightIcon20Regular } from './ArrowDim2DiagMaxRightIcon20Regular';
import { ArrowDim2DiagMaxRightIcon20Solid } from './ArrowDim2DiagMaxRightIcon20Solid';
import { ArrowDim2DiagMaxRightIcon24Regular } from './ArrowDim2DiagMaxRightIcon24Regular';
import { ArrowDim2DiagMaxRightIcon24Solid } from './ArrowDim2DiagMaxRightIcon24Solid';
import { ArrowDim2DiagMaxRightIcon32Regular } from './ArrowDim2DiagMaxRightIcon32Regular';
import { ArrowDim2DiagMaxRightIcon64Regular } from './ArrowDim2DiagMaxRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowDim2DiagMaxRightIcon16Light,
        regular: ArrowDim2DiagMaxRightIcon16Regular,
        solid: ArrowDim2DiagMaxRightIcon16Solid,
    },
    20: {
        light: ArrowDim2DiagMaxRightIcon20Light,
        regular: ArrowDim2DiagMaxRightIcon20Regular,
        solid: ArrowDim2DiagMaxRightIcon20Solid,
    },
    24: {
        regular: ArrowDim2DiagMaxRightIcon24Regular,
        solid: ArrowDim2DiagMaxRightIcon24Solid,
    },
    32: {
        regular: ArrowDim2DiagMaxRightIcon32Regular,
    },
    64: {
        regular: ArrowDim2DiagMaxRightIcon64Regular,
    },
};
export var ArrowDim2DiagMaxRightIcon = forwardRef('ArrowDim2DiagMaxRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
